import { Body, Flex, Heading, Title } from '@teko/ds-mobile';
import { formatCurrency } from '@teko/teko-ecommerce';
import { useProductDetailState, useTenantConfig } from 'contexts';
import { useGetPriceDetailPage } from 'modules/product-detail/hooks/useGetPriceDetailPage';
import { isShowRetailPrice } from 'modules/product-detail/shared/helpers';

export const ProductPrice = () => {
  const { numberDisplayFormat, isMobile } = useTenantConfig();
  const { calculatePrice } = useGetPriceDetailPage();
  const { price } = useProductDetailState();

  const supplierRetailPrice =
    formatCurrency(
      calculatePrice?.supplierRetailPrice as number,
      numberDisplayFormat,
    ) || '';
  const latestPrice =
    formatCurrency(price?.finalPrice as number, numberDisplayFormat) || '';
  const discountPercent = price?.discountPercent;

  const showRetailPrice =
    supplierRetailPrice &&
    isShowRetailPrice(
      calculatePrice?.supplierRetailPrice as number,
      price?.finalPrice as number,
    );

  const isShowDiscount = !!discountPercent;

  return (
    <Flex direction="column" align="start" marginTop="s8">
      {(showRetailPrice || isShowDiscount) && (
        <Flex direction="row" gap="s8" height="1rem">
          {showRetailPrice && (
            <Body level={1} decoration="line-through" color="textSecondary">
              {supplierRetailPrice}
            </Body>
          )}
          {isShowDiscount && (
            <Body level={1} color="#F5222D">
              {discountPercent}
            </Body>
          )}
        </Flex>
      )}
      {isMobile ? (
        <Title level={1} color="primary500">
          {latestPrice}
        </Title>
      ) : (
        <Heading level={4} color="primary500">
          {latestPrice}
        </Heading>
      )}
    </Flex>
  );
};
